var Anhui = "安徽省";
var Beijing = "北京";
var Chongqing = "重庆市";
var Fujian = "福建省";
var Gansu = "甘肃省";
var Guangdong = "广东省";
var Guangxi = "广西省";
var Guizhou = "贵州省";
var Hainan = "海南省";
var Hebei = "河北省";
var Heilongjiang = "黑龙江省";
var Henan = "河南省";
var Hubei = "湖北省";
var Hunan = "湖南省";
var Jiangsu = "江苏省";
var Jiangxi = "江西省";
var Jilin = "吉林省";
var Liaoning = "辽宁省";
var Ningxia = "宁夏";
var Qinghai = "青海省";
var Shaanxi = "陕西省";
var Shandong = "山东省";
var Shanghai = "上海市";
var Shanxi = "山西省";
var Sichuan = "四川省";
var Tianjin = "天津市";
var Tibet = "西藏";
var Xinjiang = "新疆";
var Yunnan = "云南省";
var Zhejiang = "浙江省";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "内蒙古",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
